/**
 * Created by Ivan on 23.12.2025
 */

const LightningRushMarkMerge2 = cc.Node.extend({
    ctor: function () {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.showBg();
        this.showIcon();
        this.showLabel();

        this.setAlignment(cleverapps.styles.LightningRushMarkMerge2);
    },

    showBg: function () {
        const spine = this.bg = new cleverapps.Spine(bundles.main.jsons.cloud_animation_json);
        this.addChild(spine);
        spine.setAnimation(0, "animation", false);
        spine.setAlignment(cleverapps.styles.LightningRushMarkMerge2.cloud);
    },

    showIcon: function () {
        const icon = new cc.Sprite(bundles.tournament_icon.frames.lighting_rush_icon);
        this.bg.addChild(icon);
        icon.setAlignment(cleverapps.styles.LightningRushMarkMerge2.icon);
        this.showAnimation(icon);
    },

    showLabel: function () {
        const styles = cleverapps.styles.LightningRushMarkMerge2.text;

        const label = cleverapps.UI.generateOnlyText("+1", cleverapps.styles.FONTS.MISSION_MARK_TEXT);
        this.bg.addChild(label);
        label.setAlignment(styles);
        this.showAnimation(label);
    },

    showAnimation: function (node) {
        node.setCascadeOpacityEnabledRecursively(true);
        node.setOpacity(0);
        node.setScale(0.8);

        node.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.FadeIn(0.25),
                new cc.ScaleTo(0.25, 1).easing(cc.easeBackOut())
            ),
            new cc.DelayTime(0.45),
            new cc.Spawn(
                new cc.FadeOut(0.25),
                new cc.ScaleTo(0.25, 0.8).easing(cc.easeBackIn())
            )
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MISSION_MARK_TEXT: {
        size: 65,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    }
});

cleverapps.styles.LightningRushMarkMerge2 = {
    x: { align: "center", dx: 50 },
    y: { align: "top", dy: 65 },

    text: {
        x: { align: "center", dx: -35 },
        y: { align: "center", dy: 0 },
        offsetY: 30
    },

    icon: {
        x: { align: "center", dx: 35 },
        y: { align: "center", dy: 0 }
    },

    cloud: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
